import React from "react";
import DebateHeader from "../../../Components/Functionality/DebateHeader";
import RadioCardBlock from "../../../Components/Functionality/RadioCardBlock";
import { useCreateDebateContext } from "../../../Context/CreateDebateContext";
import { useSubworkspaceStore } from "../../../Context/store";
import { useWorkspaceStore } from "../../../Context/store";
import DebateFooter from "../../../Components/Functionality/DebateFooter";
import { usePlan } from "../../../Context/PlanContext";
import { useNavigate } from "react-router-dom";

const SelectVisibility = ({ handleNext, handleBack}) => {
  const { debateInfo, handleStateUpdate } =
    useCreateDebateContext();
  const { selectedWorkspace } = useWorkspaceStore();
  const { selectedSubWorkspace } = useSubworkspaceStore();
  const {currentPlan} = usePlan();
  const navigate = useNavigate();

  const content = {
    headLine: "Visibility",
    baseLine: "Office-party",
    page: 2,
    extraDetail: [
      {
        opt: `Public-anyone in ${selectedWorkspace?.workSpaceName}`,
        subOpt: "",
        value: "public",
      },
      {
        opt: `Semi-Public - anyone in ${selectedSubWorkspace?.subWorkSpaceName}`,
        subOpt: "",
        value: "semipublic",
      },
      {
        opt: "Private - Only specific people",
        subOpt: "Can only be viewed or joined by invitation",
        value: "private",
        notHasAccess: !currentPlan?.privateDebate,
      },
    ],
    pageName: "DebatePreference",
  };
  const handleState = (value) => {
    const IsDebateSemiPublic = value === "semipublic" ? true : false;
    const IsDebatePublic = value === "public" ? true : false;
    const IsDebatePrivate = value === "private" ? true : false;
    handleStateUpdate({
      ...debateInfo,
      IsDebateSemiPublic,
      IsDebatePublic,
      IsDebatePrivate,
    });
  };

  const Visibility = debateInfo?.IsDebatePublic
    ? "public"
    : debateInfo?.IsDebateSemiPublic
    ? "semipublic"
    : debateInfo?.IsDebatePrivate
    ? "private"
    : "";

  const selectedVisibility =
    debateInfo?.IsDebatePrivate ||
    debateInfo?.IsDebatePublic ||
    debateInfo?.IsDebateSemiPublic;
  return (
    <div className="flex flex-col gap-4">
      <DebateHeader content={content} />
      <RadioCardBlock
        content={content}
        status={Visibility}
        setStatus={(value) => handleState(value)}
        navigate={navigate}
      />
      <DebateFooter
        isNext={!selectedVisibility}
        handleBack={handleBack}
        handleNext={handleNext}
      />{" "}
    </div>
  );
};

export default SelectVisibility;
